import { Col, InputNumber, Slider, Space } from 'antd';
import { Button, Number } from '..';
import styles from './index.module.less';
import { t } from 'i18next';

const RangeSlider = (props) => {
  const { range, setField, value = [], label, compact = true, type, formatValue } = props;

  // Optional: render the end labels and the drag tooltip with the caller's own formatter. Without
  // one the shared <Number> is used exactly as before.
  const show = (v) => (formatValue ? formatValue(v) : <Number compact={compact} type={type} value={v} />);

  const marks = {
    [range[0]]: { label: show(value[0] ? value[0] : range[0]) },
    [range[1]]: { label: show(value[1] ? value[1] : range[1]) },
  };

  const onChange = (newValue) => {
    setField(newValue);
  };

  const onResetClick = () => {
    setField([], true);
  };

  return (
    <>
      <Space align="center" className="w-100" style={{ justifyContent: 'space-between' }}>
        <label className="d-block" style={{ flex: 1 }}>
          {label}
        </label>
        <Button type="link" onClick={onResetClick} style={{ paddingInlineEnd: '2px' }}>
          {t('Reset')}
        </Button>
      </Space>

      <Col>
        <Space style={{ alignItems: 'baseline' }} className={styles.inputSpacer}>
          <InputNumber
            min={range[0]}
            max={range[1]}
            style={{ width: '100%' }}
            placeholder={t('Min')}
            value={value[0] && value[0]}
            onChange={(e) => {
              onChange([e, value[1]]);
            }}
          />
          <div style={{ marginInline: '8px' }}>To</div>
          <InputNumber
            min={range[0]}
            max={range[1]}
            placeholder={t('Max')}
            style={{ width: '100%' }}
            value={value[1] && value[1]}
            onChange={(e) => {
              onChange([value[0], e]);
            }}
          />
        </Space>
        <Col span={24}>
          <Slider
            style={{ '--slider-margin': 0 }}
            className={styles.rangeSlider}
            range
            marks={marks}
            min={range[0]}
            max={range[1]}
            onChange={onChange}
            value={value}
            tooltip={{
              formatter: (value) => show(value),
            }}
          />
        </Col>
      </Col>
    </>
  );
};

export default RangeSlider;
